export default __webpack_public_path__ + "static/media/white_message.326149eb.svg";